function twoDigits(value) {
    if (value.toString().length <= 1) {
      return '0' + value.toString();
    }

    return value.toString();
  }


  function parseDate(str) {
    return str.match(/(\d{4})-(\d{2})-(\d{2})\s(\d{2}):(\d{2})/).slice(1, 6);
 }

  $(function() {
    // Sets unit totals
    window.setInterval(function() {

      var progress_container =  document.querySelector('.progress-timer--units-container');
      if(progress_container != null){
        
      
      var starttime = progress_container.dataset.start;
      var endtime = progress_container.dataset.end;

      var now = Math.trunc((new Date()).getTime() / 1000);
      var start = Math.trunc(Date.parse(starttime) / 1000);
      var deadline = Math.trunc(Date.parse(endtime) / 1000);
      
	  var percentage = Math.min(Math.round(((now - start) / (deadline - start)) * 100), 100);
      var secondsRemaining = deadline - now;
      
      if (secondsRemaining < 0) {
        secondsRemaining = 0;
      }

      document.getElementById('progress-timer--days').innerHTML = twoDigits(Math.trunc((secondsRemaining) / 60 / 60 / 24));
      document.getElementById('progress-timer--hours').innerHTML = twoDigits(Math.trunc((secondsRemaining) / 60 / 60) % 24);
      document.getElementById('progress-timer--minutes').innerHTML = twoDigits(Math.trunc((secondsRemaining) / 60) % 60);
      document.getElementById('progress-timer--seconds').innerHTML = twoDigits((secondsRemaining) % 60);
      
      document.getElementById('progress-timer--bar-bg').style.width = percentage + '%';

    }

    }, 1000);
  });